import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { InvFileAttachment } from 'src/models';

  // Usage:
  // Note: documents array, attachedToType and attachedToId are all required for component to function.
  // Input attachedToType must have value 'inventory' or 'traveler'
    // <app-inventory-documents
    //   [documents]="documents"
    //   [attachedToId]="inventoryItem.inventoryItemId"
    //   [attachedToType]="'inventory'"
    //   (RowAdded)="loadInventoryItemDocuments()"
    //   (RowDeleted)="loadInventoryItemDocuments()"
    // ></app-inventory-documents>
@Component({
  selector: 'app-inventory-documents',
  templateUrl: './inventory-documents.component.html',
  styleUrls: ['./inventory-documents.component.css']
})
export class InventoryDocumentsComponent implements OnInit {

  @Input() documents: InvFileAttachment[]
  @Input() attachedToId = 0;
  @Input() attachedToType: string = '';
  @Output() RowAdded = new EventEmitter();
  @Output() RowDeleted = new EventEmitter();

  allowedExtensions: string = ".jpg,.png,.pdf";
  maxFileSize:number = 4194304;
  attachedToTypeId: number;

  constructor() { }

  ngOnInit(): void {
    switch(this.attachedToType) {
      case 'inventory' :
            this.attachedToTypeId = 1;
            break;
      case 'traveler' :
            this.attachedToTypeId = 2;
            break;
      default: console.log('unknown attachedToType');
            break;
    }
  }

  public addRowClick() {
    if (this.documents) {
      this.documents.push(new InvFileAttachment());
    }
  }

  public disableAddButton(): boolean {
    return (this.attachedToId == 0 || (this.documents && this.documents.length !== 0 && this.documents[this.documents.length - 1].fileAttachmentId == 0));
  }

  private rowAdded() {
    this.RowAdded.emit();
  }

  private rowDeleted() {
    this.RowDeleted.emit();
  }
}
